import { ModalPanel } from './ModalSection';
import { WARNING_NOTICE_STYLE } from '../../utils';

const EnviarRespuestaAviso = () => (
    <ModalPanel className="p-3 mb-4 rounded" style={WARNING_NOTICE_STYLE}>
        Una vez enviada la respuesta, no se podrá modificar. El estado pasará
        automáticamente a{' '}
        <span className="fw-semibold">En revisión</span> y{' '}
        <span className="fw-semibold">Atención al cliente</span> recibirá una
        notificación inmediata.
    </ModalPanel>
);

export default EnviarRespuestaAviso;
